import React from 'react';
import { SubHeader, Label, Form } from './Form';
import { TermAndService } from './TermAndService';

export const RegistrationDetails = ({
  i18n,
  closeModal,
  setModalObject,
  data,
  saveRegistration,
  callback,
  setOpen,
  isFlexRegistration,
  setregistrationPopup,
  setregistrationcolorPopup,
  open,
  captcha
}) => {
  const Information = () =>
    data?.initialTrucks ? (
      <>
        <SubHeader text={i18n.t('registration.paymentConfirmation')} className="paymentRegistration" variant="h2" />
        <Label className="countreg">
          <Label>{i18n.t('registration.noOfTrucks')}</Label>
          <Label>{data.initialTrucks}</Label>
        </Label>
        <Label className="countreg">
          <Label>{i18n.t('registration.costperTruck')}</Label>
          <Label>{data.selectedItem.cost}</Label>
        </Label>
        <Label className="countreg">
          <Label>{i18n.t('registration.salesTax')}</Label>
          <Label>{data.selectedItem.salesTax}</Label>
        </Label>
        <Label className="countreg">
          <Label>{i18n.t('registration.discount')}</Label>
          <Label>0.00</Label>
        </Label>
        <Label className="totalAmountreg">
          <Label>{i18n.t('registration.total')}</Label>
          <Label>{data.selectedItem.totalAmount}</Label>
        </Label>
      </>
    ) : null;
  return (
    <div>
      <Information />
      <Form
        type="client"
        direction="row"
        className="paymentForm"
        handleOnSubmit={() => {
          setregistrationPopup(534);
          setregistrationcolorPopup(false);
          setModalObject({
            header: '',
            content: () => (
              <TermAndService
                i18n={i18n}
                closeModal={closeModal}
                data={data}
                saveRegistration={saveRegistration}
                callback={callback}
                setOpen={setOpen}
                open={open}
                setModalObject={setModalObject}
                isFlexRegistration={isFlexRegistration}
                setregistrationPopup={setregistrationPopup}
                setregistrationcolorPopup={setregistrationcolorPopup}
                captcha={captcha}
              />
            )
          });
        }}
        handleOnCancel={() => {
          setregistrationPopup(326);
          closeModal();
        }}
        fields={[
          { type: 'reset', value: i18n.t('common.cancel') },
          { type: 'submit', value: i18n.t('registration.confirm') }
        ]}
      />
    </div>
  );
};
